module.exports = __webpack_public_path__ + "img/error.02a1f7a8.svg";